export const colors = {
  black: '#000000',
  white: '#ffffff',
  gray: '#616365',
  lightGray: '#f8f8f8',
  middleGray: '#D8D8D8',
  darkGray: '#9d9fa2',
  darkerGray: '#636466',
  lightBlue: '#e5f0f6',
  blue: '#1A77B9',
  darkBlue: '#2F3490',
  blackOverlay: 'rgba(0, 0, 0, .6)',
  green: '#71B247',
  greenYellow: '#A7B03A',
  yellowGreen: '#CDAF30',
  yellow: '#EEAB29',
  yellowOrange: '#DAAF2E',
  orange: '#F09A2C',
  orangeRed: '#F38630',
  red: '#EB5034',
};

export const font = {
  primary: 'interstate-condensed, sans-serif',
  secondary: 'interstate, sans-serif',
};

export const spacing = {
  headerHeight: '96px',
  headerMobile: '80px',
  headerAlert: '125px',
};

export const breakpoints = {
  mobile: 480,
  ipadLand: 1024,
  ipadMid: 960,
  midTab: 896,
  ipadPort: 768,
  pageWidth: 1123,
};

export const misc = {
  sectionMargin: 100,
  sectionMobileMargin: 50,
  animSpeed: '.3s',
};
